import App from 'records/App';
import Base from 'records/Base';

import { REHYDRATE } from 'redux-persist/constants';
import {
  APP_TOGGLE_NAV_DRAWER,
} from 'actions/app';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new App(),
});

const actionsMap = {
  [APP_TOGGLE_NAV_DRAWER]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new App({
        navDrawerOpen: action.data,
      }),
    });
  },
  [REHYDRATE]: (state, action) => {
    const appPayload = action.payload.app;
    if (appPayload) {
      return new Base({
        loading: appPayload.loading,
        errorMessage: appPayload.errorMessage,
        data: new App(appPayload.data),
      });
    }
    return state;
  },
};

export default function app(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
